import { render, staticRenderFns } from "./psList.vue?vue&type=template&id=04243b7f&scoped=true"
import script from "./psList.vue?vue&type=script&lang=js"
export * from "./psList.vue?vue&type=script&lang=js"
import style0 from "./psList.vue?vue&type=style&index=0&id=04243b7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04243b7f",
  null
  
)

export default component.exports